var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",class:[_vm.skinClasses],attrs:{"id":"app"}},[(
      !_vm.$route.path.includes('approve_ownership') &&
      !_vm.$route.path.includes('/files/terms') &&
      !_vm.$route.path.includes('/files/risk') &&
      !_vm.$route.path.includes('/read-files')
    )?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }